const firebaseConfig = {
    apiKey: "AIzaSyAqpOlyT7KMK470Cm-H9kqIfnzJPWW9gLw",
    authDomain: "hotel-night-queen.firebaseapp.com",
    projectId: "hotel-night-queen",
    storageBucket: "hotel-night-queen.appspot.com",
    messagingSenderId: "369303574728",
    appId: "1:369303574728:web:1b0fb3cd49c2a74b0e2dfd"
  };

export default firebaseConfig;